import React from 'react';

export const Link = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1667 5.83337H10.8334V7.50004H14.1667C15.5417 7.50004 16.6667 8.62504 16.6667 10C16.6667 11.375 15.5417 12.5 14.1667 12.5H10.8334V14.1667H14.1667C16.4667 14.1667 18.3334 12.3 18.3334 10C18.3334 7.70004 16.4667 5.83337 14.1667 5.83337ZM9.16669 12.5H5.83335C4.45835 12.5 3.33335 11.375 3.33335 10C3.33335 8.62504 4.45835 7.50004 5.83335 7.50004H9.16669V5.83337H5.83335C3.53335 5.83337 1.66669 7.70004 1.66669 10C1.66669 12.3 3.53335 14.1667 5.83335 14.1667H9.16669V12.5ZM6.66669 9.16671H13.3334V10.8334H6.66669V9.16671Z"
      fill={fill}
    />
  </svg>
);

export const Copy = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
      fill={fill}
    />
  </svg>
);

export const Subaction = ({
  'data-testid': dataTestId,
  fill = '#687587',
  width = '24',
  height = '24',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20 9V5H4V9H20ZM20 19V15H10V19H20ZM3 3H21C21.55 3 22 3.45 22 4V10C22 10.55 21.55 11 21 11H3C2.45 11 2 10.55 2 10V4C2 3.45 2.45 3 3 3ZM9 13H21C21.55 13 22 13.45 22 14V20C22 20.55 21.55 21 21 21H9C8.45 21 8 20.55 8 20V14C8 13.45 8.45 13 9 13ZM2 13V16C2 17.1046 2.89543 18 4 18H6V16H4V13H2Z"
      fill={fill}
    />
  </svg>
);

export const Mirror = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 8H14V11H11V13H14V16H16V13H19V11H16V8ZM2 12C2 9.21 3.64 6.8 6.01 5.68V3.52C2.52 4.76 0 8.09 0 12C0 15.91 2.52 19.24 6.01 20.48V18.32C3.64 17.2 2 14.79 2 12ZM15 3C10.04 3 6 7.04 6 12C6 16.96 10.04 21 15 21C19.96 21 24 16.96 24 12C24 7.04 19.96 3 15 3ZM15 19C11.14 19 8 15.86 8 12C8 8.14 11.14 5 15 5C18.86 5 22 8.14 22 12C22 15.86 18.86 19 15 19Z"
      fill={fill}
    />
  </svg>
);

export const Remind = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64003 5.36 6.00003 7.92 6.00003 11V16L4.00003 18V19H20V18L18 16ZM16 17H8.00003V11C8.00003 8.52 9.51003 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17ZM7.58003 4.08L6.15003 2.65C3.75003 4.48 2.17003 7.3 2.03003 10.5H4.03003C4.18003 7.85 5.54003 5.53 7.58003 4.08ZM19.97 10.5H21.97C21.82 7.3 20.24 4.48 17.85 2.65L16.43 4.08C18.45 5.53 19.82 7.85 19.97 10.5Z"
      fill={fill}
    />
  </svg>
);

export const Repeat = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 7H17V10L21 6L17 2V5H5V11H7V7ZM17 17H7V14L3 18L7 22V19H19V13H17V17Z"
      fill={fill}
    />
  </svg>
);

export const AddToMeeting = ({
  fill = '#687587',
  'data-testid': dataTestId,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6 6.60132C21.5137 6.34235 21.4274 6.08337 21.1684 5.99704L17.0248 3.66626C16.5068 3.49361 16.0752 3.66626 15.8162 4.09789C15.7299 4.27054 15.6436 4.44319 15.7299 4.70216C15.7299 4.87481 15.9025 5.13379 16.0752 5.30644L18.3197 6.515H18.2333C15.7299 7.2056 13.6581 8.84578 12.3632 11.1766C12.1906 11.5219 12.0179 11.7808 11.9316 12.1262C11.8453 11.8672 11.7589 11.6945 11.6726 11.4355C10.3777 9.10476 8.30591 7.37825 5.80247 6.60132H5.71615L7.96061 5.47909C8.21958 5.30644 8.30591 5.13379 8.39224 4.87481C8.47856 4.70216 8.39224 4.44319 8.30591 4.35686C8.13326 3.75258 7.70163 3.57993 7.18368 3.75258L2.86741 5.91072C2.69476 6.08337 2.52211 6.34235 2.43578 6.515C2.34946 6.68765 2.43578 6.94662 2.52211 7.11928L4.68024 11.3492C4.93922 11.6945 5.45717 11.9535 5.8888 11.6945L6.06145 11.5219C6.32043 11.2629 6.40675 10.8313 6.2341 10.486L5.11187 8.15518H5.19819C9.25549 9.53639 11.4999 14.198 10.5504 19.2912C10.464 19.3775 10.464 19.3775 10.464 19.4638C10.464 19.7228 11.0683 19.9818 11.8453 19.9818C12.6222 19.9818 13.2265 19.8091 13.2265 19.4638C13.2265 19.3775 13.2265 19.3775 13.1401 19.2912L13.0538 18.9459C12.2769 13.8527 14.694 9.27741 18.8376 8.06886H18.9239L17.6291 10.3996C17.4564 10.7449 17.5427 11.1766 17.8017 11.4355L17.9744 11.6082C18.406 11.8672 18.9239 11.6945 19.1829 11.2629L21.5137 7.11928C21.6 6.94662 21.6 6.77397 21.6 6.60132Z"
      fill={fill}
      stroke={fill}
      strokeWidth="0.4"
    />
  </svg>
);

export const AddTo1on1 = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z"
      fill={fill}
    />
  </svg>
);

export const Delete = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z"
      fill={fill}
    />
  </svg>
);

export const EffortLow = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="effort_low">
      <g id="effort_low_2">
        <rect
          id="Rectangle 17 Copy"
          x="6"
          y="17.3846"
          width="14"
          height="4.61538"
          rx="1"
          fill="#208EC5"
        />
        <rect
          id="Rectangle 17 Copy 3"
          opacity="0.4"
          x="6"
          y="9.69244"
          width="14"
          height="4.61538"
          rx="1"
          fill="#55B1DF"
        />
        <rect
          id="Rectangle 17 Copy 4"
          opacity="0.4"
          x="6"
          y="2"
          width="14"
          height="4.61539"
          rx="1"
          fill="#55B1DF"
        />
      </g>
    </g>
  </svg>
);

export const EfforMedium = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="effort_medium">
      <g id="effort_medium_2">
        <rect
          id="Rectangle 17 Copy"
          x="5"
          y="17.3846"
          width="14"
          height="4.61538"
          rx="1"
          fill="#208EC5"
        />
        <rect
          id="Rectangle 17 Copy 3"
          x="5"
          y="9.69238"
          width="14"
          height="4.61538"
          rx="1"
          fill="#208EC5"
        />
        <rect
          id="Rectangle 17 Copy 4"
          opacity="0.4"
          x="5"
          y="2"
          width="14"
          height="4.61539"
          rx="1"
          fill="#55B1DF"
        />
      </g>
    </g>
  </svg>
);

export const EffortHigh = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="effort_high">
      <path
        id="effort_high_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C5.44772 2 5 2.44771 5 3V5.61539C5 6.16767 5.44772 6.61539 6 6.61539H18C18.5523 6.61539 19 6.16767 19 5.61539V3C19 2.44772 18.5523 2 18 2H6ZM5 10.6924C5 10.1401 5.44772 9.69238 6 9.69238H18C18.5523 9.69238 19 10.1401 19 10.6924V13.3078C19 13.8601 18.5523 14.3078 18 14.3078H6C5.44772 14.3078 5 13.8601 5 13.3078V10.6924ZM5 18.3846C5 17.8323 5.44772 17.3846 6 17.3846H18C18.5523 17.3846 19 17.8323 19 18.3846V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V18.3846Z"
        fill="#208EC5"
      />
    </g>
  </svg>
);

export const StatusPause = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="progress_pause">
      <path
        id="progress_pause_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4.10524 12C4.10524 16.3618 7.63813 19.8947 12 19.8947C16.3618 19.8947 19.8947 16.3618 19.8947 12C19.8947 7.63813 16.3618 4.10524 12 4.10524C7.63813 4.10524 4.10524 7.63813 4.10524 12ZM8.42859 16.2857H10.9286V7.71429H8.42859V16.2857ZM15.5714 16.2857H13.0714V7.71429H15.5714V16.2857Z"
        fill="#687587"
      />
    </g>
  </svg>
);

export const StatusNext = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="progress_next">
      <path
        id="progress_next_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5024 1L23 12L11.5024 23V16.0063H4.44119C3.51146 16.0063 2.6637 15.5722 2.06594 15.0008C1.47025 14.4313 1 13.6066 1 12.6845V11.3164C1 10.3782 1.48526 9.57872 2.10187 9.04073C2.71901 8.50228 3.55776 8.14207 4.44119 8.14207H11.5024V1ZM13.6554 6.0178V10.2648H4.44119C4.1418 10.2648 3.79822 10.3953 3.52873 10.6304C3.25873 10.866 3.15307 11.123 3.15307 11.3164V12.6845C3.15307 12.8931 3.27373 13.1986 3.56467 13.4767C3.85352 13.7528 4.1881 13.8835 4.44119 13.8835H13.6554V17.9822L19.9083 12L13.6554 6.0178Z"
        fill="#687587"
      />
    </g>
  </svg>
);

export const StatusDoing = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="progress_doing">
      <path
        id="progress_doing_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 19.5V4.5C16.1421 4.5 19.5 7.85786 19.5 12C19.5 16.1421 16.1421 19.5 12 19.5M12 2C6.4775 2 2 6.47645 2 12C2 17.5225 6.4775 22 12 22C17.5235 22 22 17.5225 22 12C22 6.47645 17.5235 2 12 2"
        fill="#208EC5"
      />
    </g>
  </svg>
);

export const StatusDone = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="progress_done">
      <path
        id="progress_done_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4866 4.51966C21.885 4.9013 22 5.39485 22 5.76414C22 6.13763 21.8824 6.63822 21.4729 7.0216L9.25243 19.3311C8.57613 20.0199 7.45701 20.02 6.78064 19.3313L2.4841 15.0053L2.46565 14.9849C1.84478 14.2983 1.84478 13.2585 2.46565 12.572L2.56097 12.4779C2.82487 12.2457 3.22274 12.0143 3.75296 12.0143C4.17983 12.0143 4.67435 12.1774 5.00887 12.5888L8.00093 15.6084L19.007 4.5293C19.67 3.85413 20.7856 3.79701 21.4866 4.51966Z"
        fill="#289941"
      />
    </g>
  </svg>
);

export const ConfidenceGreen = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="RAG_Green">
      <path
        id="RAG_Green_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.532 22C20.4473 22 22 20.4473 22 18.532V5.46679C22 3.55151 20.4473 2 18.532 2H5.46795C3.55268 2 2 3.55151 2 5.46679V18.532C2 20.4473 3.55268 22 5.46795 22H18.532ZM12.7797 17C14.0544 17 15.328 16.6794 16 16.4474V11.2883H12.409V13.0165H13.8966V15.0666C13.7244 15.154 13.3238 15.2123 12.8228 15.2123C11.0351 15.2123 9.79025 14.0197 9.79025 12.0012C9.79025 9.87831 11.1642 8.83143 12.9806 8.83143C14.0401 8.83143 14.6978 9.02089 15.2275 9.25285L15.6855 7.47972C15.2132 7.24775 14.2541 7 13.0093 7C9.84765 7 7.51466 8.86058 7.50031 12.1166C7.48596 13.5545 7.97265 14.8334 8.85992 15.6774C9.7472 16.5494 11.0207 17 12.7797 17Z"
        fill="#289941"
      />
    </g>
  </svg>
);

export const ConfidenceAmber = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="RAG_Amber">
      <path
        id="RAG_Amber_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5262 22C20.445 22 22 20.445 22 18.5262V5.47493C22 3.55616 20.445 2 18.5262 2H5.47376C3.555 2 2 3.55616 2 5.47493V18.5262C2 20.445 3.555 22 5.47376 22H18.5262ZM12.4478 10.6193L13.1313 12.7421H10.7071L11.358 10.6193C11.4647 10.2763 11.5651 9.86883 11.6634 9.47042C11.7302 9.19914 11.7961 8.93209 11.8621 8.6925H11.8947C11.9263 8.80686 11.959 8.92692 11.9926 9.05048C12.133 9.56594 12.29 10.1423 12.4478 10.6193ZM9.571 17L10.3496 14.4334H13.4887L14.3339 17H17L13.6028 7H10.3496L7 17H9.571Z"
        fill="#FB810F"
      />
    </g>
  </svg>
);

export const ConfidenceRed = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="RAG_Red">
      <path
        id="RAG_Red_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.532 22C20.4473 22 22 20.4473 22 18.532V5.46679C22 3.55151 20.4473 2 18.532 2H5.46795C3.55268 2 2 3.55151 2 5.46679V18.532C2 20.4473 3.55268 22 5.46795 22H18.532ZM11.5218 11.4771H10.5214V8.73717C10.7033 8.70812 11.0552 8.66513 11.6721 8.66513C12.8425 8.67907 13.5437 9.13573 13.5437 10.0479C13.5437 10.9182 12.7924 11.4771 11.5218 11.4771ZM11.3887 7C10.0377 7 8.81586 7.08831 8 7.20683V17H10.5214V13.0969H11.2885C12.3245 13.112 12.8095 13.4502 13.1113 14.6877C13.4435 15.9101 13.7124 16.72 13.8942 17H16.5C16.342 16.7215 16.1138 15.9616 15.8664 15.1378C15.7732 14.8275 15.6773 14.5081 15.5813 14.202C15.298 13.2886 14.863 12.6263 14.0801 12.3463V12.3021C15.0475 11.993 16.065 11.1239 16.065 9.85731C16.065 8.94399 15.6986 8.25261 15.0317 7.78085C14.229 7.22078 13.0599 7 11.3887 7Z"
        fill="#D93630"
      />
    </g>
  </svg>
);

export const PriorityNormal = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="priority_normal">
      <path
        id="priority_normal_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.52813C7.32985 3.52813 3.52896 7.328 3.52896 11.9996C3.52896 16.6712 7.32985 20.4719 12 20.4719C16.6709 20.4719 20.4718 16.6712 20.4718 11.9996C20.4718 7.328 16.6709 3.52813 12 3.52813ZM12 22C6.48694 22 2 17.5141 2 11.9996C2 6.4859 6.48694 2 12 2C17.5139 2 22 6.4859 22 11.9996C22 17.5141 17.5139 22 12 22ZM12 7.50716C9.52298 7.50716 7.50935 9.52263 7.50935 11.9992C7.50935 14.4773 9.52298 16.4928 12 16.4928C14.477 16.4928 16.4914 14.4773 16.4914 11.9992C16.4914 9.52263 14.477 7.50716 12 7.50716ZM12 17.7143C8.85021 17.7143 6.2857 15.151 6.2857 11.9992C6.2857 8.84822 8.85021 6.2857 12 6.2857C15.1505 6.2857 17.7143 8.84822 17.7143 11.9992C17.7143 15.151 15.1505 17.7143 12 17.7143ZM10.1135 12C10.1135 10.9608 10.9596 10.1164 11.9998 10.1164C13.0399 10.1164 13.8853 10.9608 13.8853 12C13.8853 13.0408 13.0399 13.8852 11.9998 13.8852C10.9596 13.8852 10.1135 13.0408 10.1135 12ZM9.14285 12C9.14285 13.5758 10.4236 14.8571 11.9996 14.8571C13.5764 14.8571 14.8571 13.5758 14.8571 12C14.8571 10.4266 13.5764 9.14285 11.9996 9.14285C10.4236 9.14285 9.14285 10.4266 9.14285 12Z"
        fill="#687587"
      />
    </g>
  </svg>
);

export const PriorityHigh = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="priority_high">
      <path
        id="priority_high_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.52806C7.32984 3.52806 3.52896 7.32794 3.52896 11.9995C3.52896 16.6712 7.32984 20.4719 12 20.4719C16.6709 20.4719 20.4718 16.6712 20.4718 11.9995C20.4718 7.32794 16.6709 3.52806 12 3.52806ZM12 22C6.48694 22 2 17.5141 2 11.9996C2 6.4859 6.48694 2 12 2C17.5139 2 22 6.4859 22 11.9996C22 17.5141 17.5139 22 12 22ZM12 7.50716C9.52305 7.50716 7.50941 9.52263 7.50941 11.9992C7.50941 14.4773 9.52305 16.4928 12 16.4928C14.477 16.4928 16.4915 14.4773 16.4915 11.9992C16.4915 9.52263 14.477 7.50716 12 7.50716ZM12 17.7143C8.85021 17.7143 6.2857 15.151 6.2857 11.9992C6.2857 8.84822 8.85021 6.2857 12 6.2857C15.1505 6.2857 17.7143 8.84822 17.7143 11.9992C17.7143 15.151 15.1505 17.7143 12 17.7143ZM10.1135 12C10.1135 10.9608 10.9596 10.1164 11.9998 10.1164C13.0399 10.1164 13.8853 10.9608 13.8853 12C13.8853 13.0408 13.0399 13.8853 11.9998 13.8853C10.9596 13.8853 10.1135 13.0408 10.1135 12ZM9.14291 12.0001C9.14291 13.5758 10.4237 14.8572 11.9997 14.8572C13.5765 14.8572 14.8572 13.5758 14.8572 12.0001C14.8572 10.4266 13.5765 9.14291 11.9997 9.14291C10.4237 9.14291 9.14291 10.4266 9.14291 12.0001Z"
        fill="#208EC5"
      />
    </g>
  </svg>
);

export const PriorityHighest = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid="test-icon"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="priority_highest">
      <g id="priority_highest_2">
        <path
          id="Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.93729 4.90909C1.0209 8.83196 1.0209 15.1791 4.93729 19.0579C8.85369 22.9807 15.1903 22.9807 19.0627 19.0579C22.9791 15.135 22.9791 8.78788 19.0627 4.90909C15.1903 1.0303 8.85369 1.0303 4.93729 4.90909V4.90909ZM17.6986 17.6914C14.5743 20.8209 9.51375 20.8209 6.38944 17.6914C3.26513 14.562 3.26513 9.4931 6.38944 6.36362C9.51375 3.23414 14.5743 3.23414 17.6986 6.36362C20.8229 9.44902 20.8229 14.562 17.6986 17.6914V17.6914Z"
          fill="#208EC5"
        />
        <path
          id="Combined Shape"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1099 5.70239C11.7139 5.70239 11.3619 5.83462 11.1418 6.09909C10.8778 6.36355 10.7898 6.71617 10.7898 7.11286C10.7898 7.34794 10.8094 7.66138 10.8354 8.07929C10.8485 8.28825 10.8632 8.52333 10.8778 8.78779L11.1418 12.7547C11.1858 13.2837 11.2739 13.6363 11.4059 13.9007C11.5379 14.1652 11.7139 14.2974 12.0219 14.2974C12.286 14.2974 12.506 14.1652 12.638 13.9007C12.77 13.6363 12.858 13.2837 12.902 12.7988L13.2541 8.69964C13.2981 8.34702 13.2981 7.95033 13.2981 7.59771C13.2981 6.98063 13.2541 6.49578 13.078 6.18724C12.902 5.8787 12.594 5.70239 12.1099 5.70239ZM12.022 18.3084C12.374 18.3084 12.638 18.1762 12.9021 17.9558C13.1661 17.7354 13.2541 17.4269 13.2101 17.0743C13.2101 16.7217 13.1221 16.4131 12.8581 16.1927C12.638 15.9724 12.33 15.8401 11.978 15.8401C11.6259 15.8401 11.3179 15.9724 11.0979 16.1927C10.8779 16.4572 10.7458 16.7217 10.7458 17.0743C10.7458 17.471 10.8779 17.7795 11.1419 17.9999C11.4059 18.2203 11.6699 18.3084 12.022 18.3084Z"
          fill="#F04A43"
        />
      </g>
    </g>
  </svg>
);

export const Note = ({
  fill = '#687587',
  'data-testid': dataTestId,
  width = 20,
  height = 20,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.3167 16.4012C18.3167 16.4012 18.3167 16.3184 18.3167 16.2356C18.3167 16.1528 18.2322 15.9871 18.2322 15.8215C18.1478 15.4902 17.9788 14.8276 17.3875 14.2479C17.134 13.9994 16.7117 13.6682 16.2893 13.5853C15.8669 13.4197 15.36 13.3369 14.8532 13.3369C13.8395 13.2541 12.8257 13.4197 11.812 13.6682C11.7275 13.6682 11.6431 13.6682 11.5586 13.751C11.7275 13.5853 11.812 13.5025 11.981 13.3369C12.4878 12.9228 12.9102 12.4259 13.4171 11.9289C13.6705 11.6805 13.9239 11.432 14.1774 11.0179C14.2618 10.9351 14.3463 10.7695 14.3463 10.6038L14.4308 10.4382V10.3554V10.1897C14.4308 10.0241 14.4308 9.85844 14.4308 9.77562V9.6928V9.6928C14.4308 9.77562 14.2618 9.19587 14.2618 9.36152C14.1774 9.27869 14.0929 9.11305 14.0084 9.11305C13.9239 9.03023 13.8395 9.03023 13.755 8.94741C13.6705 8.86459 13.586 8.86459 13.586 8.86459C13.5015 8.86459 13.5015 8.86459 13.4171 8.86459H13.3326C13.2481 8.86459 13.1636 8.86459 13.1636 8.86459C12.9947 8.86459 12.8257 8.86459 12.7413 8.94741C12.3189 9.03023 11.981 9.19588 11.6431 9.2787C11.3052 9.36152 10.9672 9.52716 10.6293 9.6928C10.038 9.94126 9.36219 10.1897 8.68637 10.4382C7.75713 10.8523 6.74341 11.1836 5.81416 11.5148C6.32102 11.1007 6.74341 10.6866 7.25027 10.2725C8.09504 9.52716 9.02428 8.86459 9.78457 8.28485C11.3896 7.04255 12.7413 6.04871 13.755 5.38615C14.6842 4.72358 15.2756 4.30948 15.2756 4.30948V4.30948C15.2756 4.30948 15.2756 4.30948 15.36 4.30948C16.0358 3.81256 16.2048 2.7359 15.6979 2.07334C15.1911 1.41078 14.0929 1.24514 13.4171 1.74206C13.4171 1.74206 12.8257 2.15616 11.8965 2.90154C10.7138 3.48128 9.36219 4.55794 7.75713 5.80025C6.99684 6.46281 6.06759 7.20819 5.22283 7.95357C4.80044 8.45049 4.29358 8.86459 3.8712 9.2787C3.44882 9.6928 2.94196 10.1897 2.51957 10.7695C2.26614 11.1007 2.01271 11.3492 1.84376 11.8461C1.75928 12.0118 1.75928 12.0946 1.6748 12.343C1.6748 12.4259 1.6748 12.5915 1.6748 12.7571C1.6748 12.9228 1.6748 13.0884 1.75928 13.2541C1.75928 13.2541 1.84376 13.5025 1.84376 13.4197V13.4197V13.4197V13.5025C1.84376 13.5853 1.92823 13.5853 1.92823 13.6682C2.09719 13.9166 2.18167 13.9994 2.35062 14.0823C2.60405 14.2479 2.85748 14.3307 3.11091 14.4135C3.53329 14.4964 3.78672 14.4964 4.04015 14.4135C4.29358 14.4135 4.46254 14.3307 4.71597 14.3307C4.9694 14.2479 5.3073 14.1651 5.64521 14.0823C6.99684 13.5853 8.26399 13.0056 9.53114 12.5087C9.70009 12.4259 9.86905 12.343 10.038 12.2602C9.78457 12.5915 9.44666 12.84 9.19323 13.1712C8.9398 13.4197 8.77085 13.6682 8.51742 13.9166C8.43294 14.0823 8.26399 14.1651 8.17951 14.3307C8.09504 14.4135 8.09504 14.4964 8.01056 14.662C8.01056 14.662 8.01056 14.7448 7.92608 14.7448C7.92608 14.8276 7.92608 14.8276 7.84161 14.9105C7.84161 14.9933 7.75713 15.2417 7.75713 15.4074C7.84161 15.8215 7.75713 15.4902 7.84161 15.6558V15.6558C7.84161 15.6558 7.92608 15.7387 7.92608 15.8215C8.01056 15.9043 8.09504 15.9043 8.17951 15.9871C8.26399 16.07 8.34847 16.07 8.34847 16.07C8.34847 16.07 8.43294 16.07 8.43294 16.1528C8.43294 16.1528 8.51742 16.1528 8.51742 16.2356H8.6019C8.68637 16.2356 8.68637 16.2356 8.77085 16.2356C8.85533 16.2356 8.85533 16.2356 8.85533 16.2356C8.9398 16.2356 8.9398 16.2356 9.02428 16.2356C9.19323 16.2356 9.27771 16.2356 9.36219 16.1528C9.53114 16.07 9.70009 16.07 9.86905 15.9871C10.1225 15.9043 10.4604 15.8215 10.7138 15.7387C11.2207 15.573 11.7275 15.4074 12.2344 15.2417C13.1636 14.9933 14.0084 14.8276 14.6842 14.8276C15.36 14.8276 15.8669 14.9933 16.1203 15.2417C16.3738 15.4902 16.5427 15.8215 16.6272 16.07C16.7117 16.3184 16.7117 16.4841 16.7117 16.4841V16.4841C16.7961 16.8982 17.2185 17.2294 17.6409 17.1466C18.0633 17.2294 18.4012 16.8153 18.3167 16.4012V16.4012Z"
      fill={fill}
    />
  </svg>
);

export const File = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.4341 16.5659C2.52197 14.6538 2.52197 11.5591 4.4341 9.64698L11.0385 3.04256C12.4286 1.65248 14.6804 1.65248 16.0705 3.04256C17.4605 4.43263 17.4605 6.68442 16.0705 8.0745L10.724 13.4209C9.85602 14.2889 8.44708 14.2889 7.57907 13.4209C6.71106 12.5529 6.71106 11.144 7.57907 10.276L12.2965 5.55853L13.5545 6.81651L8.78044 11.5906C8.4345 11.9365 9.06349 12.5655 9.40944 12.2196L14.8125 6.81651C15.5044 6.12462 15.5044 4.99243 14.8125 4.30054C14.1206 3.60865 12.9884 3.60865 12.2965 4.30054L5.69209 10.905C4.47813 12.1189 4.47813 14.094 5.69209 15.3079C6.90604 16.5219 8.88108 16.5219 10.095 15.3079L16.0705 9.33248L17.3285 10.5905L11.353 16.5659C9.44089 18.478 6.34624 18.478 4.4341 16.5659Z"
      fill={fill}
    />
  </svg>
);

export const Tag = ({
  fill = '#687587',
  'data-testid': dataTestId,
  width = '20',
  height = '20',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8415 9.64984L10.3415 2.14984C10.0415 1.84984 9.62484 1.6665 9.1665 1.6665H3.33317C2.4165 1.6665 1.6665 2.4165 1.6665 3.33317V9.1665C1.6665 9.62484 1.84984 10.0415 2.15817 10.3498L9.65817 17.8498C9.95817 18.1498 10.3748 18.3332 10.8332 18.3332C11.2915 18.3332 11.7082 18.1498 12.0082 17.8415L17.8415 12.0082C18.1498 11.7082 18.3332 11.2915 18.3332 10.8332C18.3332 10.3748 18.1415 9.94984 17.8415 9.64984ZM10.8332 16.6748L3.33317 9.1665V3.33317H9.1665V3.32484L16.6665 10.8248L10.8332 16.6748V16.6748Z"
      fill={fill}
    />
    <path
      d="M5.4165 6.6665C6.10686 6.6665 6.6665 6.10686 6.6665 5.4165C6.6665 4.72615 6.10686 4.1665 5.4165 4.1665C4.72615 4.1665 4.1665 4.72615 4.1665 5.4165C4.1665 6.10686 4.72615 6.6665 5.4165 6.6665Z"
      fill={fill}
    />
  </svg>
);

export const Related = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.65408 4.55145C5.32966 3.83383 4.59909 3.3335 3.74984 3.3335C2.59924 3.3335 1.6665 4.25189 1.6665 5.38478C1.6665 6.51767 2.59924 7.43606 3.74984 7.43606C4.59909 7.43606 5.32966 6.93573 5.65408 6.21811H9.1665V12.9489C9.1665 14.3296 10.2858 15.4489 11.6665 15.4489H14.3456C14.67 16.1665 15.4006 16.6668 16.2498 16.6668C17.4004 16.6668 18.3332 15.7484 18.3332 14.6155C18.3332 13.4827 17.4004 12.5643 16.2498 12.5643C15.4006 12.5643 14.67 13.0646 14.3456 13.7822H11.6665C11.2063 13.7822 10.8332 13.4091 10.8332 12.9489V6.21811L14.3456 6.21811C14.67 6.93573 15.4006 7.43606 16.2498 7.43606C17.4004 7.43606 18.3332 6.51767 18.3332 5.38478C18.3332 4.25189 17.4004 3.3335 16.2498 3.3335C15.4006 3.3335 14.67 3.83383 14.3456 4.55144L5.65408 4.55145Z"
      fill={fill}
    />
  </svg>
);

export const Comment = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6665 14.3082L15.6915 13.3332H3.33317V3.33317H16.6665V14.3082ZM16.6665 1.6665H3.33317C2.4165 1.6665 1.6665 2.4165 1.6665 3.33317V13.3332C1.6665 14.2498 2.4165 14.9998 3.33317 14.9998H14.9998L18.3332 18.3332V3.33317C18.3332 2.4165 17.5832 1.6665 16.6665 1.6665Z"
      fill={fill}
    />
  </svg>
);

export const CommentOutlined = ({
  fill = '#687587',
  'data-testid': dataTestId,
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4925 3C16.4925 2.175 15.825 1.5 15 1.5H3C2.175 1.5 1.5 2.175 1.5 3V12C1.5 12.825 2.175 13.5 3 13.5H13.5L16.5 16.5L16.4925 3ZM15 3V12.8775L14.1225 12H3V3H15ZM4.5 9H13.5V10.5H4.5V9ZM4.5 6.75H13.5V8.25H4.5V6.75ZM4.5 4.5H13.5V6H4.5V4.5Z"
      fill={fill}
    />
  </svg>
);

export const AttachmentVertical = ({
  fill = '#687587',
  'data-testid': dataTestId,
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.375 4.5V13.125C12.375 14.7825 11.0325 16.125 9.375 16.125C7.7175 16.125 6.375 14.7825 6.375 13.125V3.75C6.375 2.715 7.215 1.875 8.25 1.875C9.285 1.875 10.125 2.715 10.125 3.75V11.625C10.125 12.0375 9.7875 12.375 9.375 12.375C8.9625 12.375 8.625 12.0375 8.625 11.625V4.5H7.5V11.625C7.5 12.66 8.34 13.5 9.375 13.5C10.41 13.5 11.25 12.66 11.25 11.625V3.75C11.25 2.0925 9.9075 0.75 8.25 0.75C6.5925 0.75 5.25 2.0925 5.25 3.75V13.125C5.25 15.405 7.095 17.25 9.375 17.25C11.655 17.25 13.5 15.405 13.5 13.125V4.5H12.375Z"
      fill={fill}
    />
  </svg>
);

export const Loop = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.23393 11.7186C2.8197 11.7186 1.6665 12.8718 1.6665 14.286C1.66635 15.7004 2.81955 16.8536 4.23393 16.8536C4.69093 16.8536 5.12606 16.7448 5.49592 16.5273C6.75791 17.5716 8.34624 18.1374 9.99992 18.1374C11.0878 18.1374 12.1322 17.8981 13.0896 17.4411C13.329 17.3323 13.4159 17.0495 13.3073 16.8319C13.1984 16.5925 12.9157 16.5055 12.698 16.6142C11.8494 17.0277 10.9573 17.2235 9.99994 17.2235C8.62912 17.2235 7.30185 16.7664 6.21393 15.9397C6.5838 15.5046 6.80145 14.9388 6.80145 14.3079C6.77959 12.8718 5.64809 11.7186 4.23387 11.7186L4.23393 11.7186ZM2.5802 14.2862C2.5802 13.3723 3.31995 12.6543 4.21209 12.6543C5.12594 12.6543 5.84397 13.394 5.84397 14.2862C5.84397 15.1783 5.10422 15.9181 4.21209 15.9181C3.31995 15.9181 2.5802 15.1782 2.5802 14.2862ZM7.32355 4.23376V4.29903C6.97538 4.42955 6.6272 4.60364 6.3009 4.79943C4.23389 6.03974 2.9283 8.23727 2.86306 10.6742C2.86306 10.9353 3.05886 11.1529 3.29819 11.1529H3.3199C3.55925 11.1529 3.7769 10.9571 3.7769 10.6959C3.86387 8.58548 4.99534 6.67097 6.80133 5.58305C7.04068 5.43066 7.28002 5.32199 7.54108 5.21317C7.93265 6.12703 8.84666 6.77978 9.91271 6.77978C11.3269 6.77978 12.4801 5.62658 12.4801 4.21236C12.4803 2.79798 11.3054 1.6665 9.89099 1.6665C8.47677 1.6665 7.32357 2.8197 7.32357 4.23393L7.32355 4.23376ZM9.89097 2.58016C10.8048 2.58016 11.5229 3.31991 11.5229 4.21204C11.5229 5.1259 10.7831 5.84393 9.89097 5.84393C8.97712 5.84393 8.25909 5.10418 8.25909 4.21204C8.25909 3.31991 8.97712 2.58016 9.89097 2.58016ZM13.8728 4.97367C13.6551 4.84314 13.3724 4.8867 13.2419 5.10419C13.1113 5.32184 13.1549 5.6046 13.3724 5.73511C15.1348 6.88831 16.201 8.82481 16.201 10.9354C16.201 11.1964 16.1793 11.4793 16.1575 11.7404C16.0269 11.7187 15.9181 11.7187 15.7876 11.7187C14.3734 11.7187 13.2202 12.8719 13.2202 14.2861C13.22 15.7005 14.3515 16.8537 15.7657 16.8537C17.18 16.8537 18.3332 15.7005 18.3332 14.2863C18.3332 13.3289 17.8109 12.502 17.0495 12.0669C17.1147 11.697 17.1364 11.3271 17.1364 10.9572C17.1366 8.52017 15.9181 6.30093 13.8728 4.97366L13.8728 4.97367ZM15.7657 15.9182C14.8519 15.9182 14.1338 15.1784 14.1338 14.2863C14.1338 13.3942 14.8736 12.6544 15.7657 12.6544C16.6796 12.6544 17.3976 13.3942 17.3976 14.2863C17.3976 15.1783 16.6797 15.9182 15.7657 15.9182V15.9182Z"
      fill={fill}
    />
  </svg>
);

export const History = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8335 2.5C6.69183 2.5 3.3335 5.85833 3.3335 10H0.833496L4.07516 13.2417L4.1335 13.3583L7.50016 10H5.00016C5.00016 6.775 7.6085 4.16667 10.8335 4.16667C14.0585 4.16667 16.6668 6.775 16.6668 10C16.6668 13.225 14.0585 15.8333 10.8335 15.8333C9.22516 15.8333 7.76683 15.175 6.71683 14.1167L5.5335 15.3C6.89183 16.6583 8.7585 17.5 10.8335 17.5C14.9752 17.5 18.3335 14.1417 18.3335 10C18.3335 5.85833 14.9752 2.5 10.8335 2.5ZM10.0002 6.66667V10.8333L13.5668 12.95L14.1668 11.9417L11.2502 10.2083V6.66667H10.0002Z"
      fill={fill}
    />
  </svg>
);

export const Workstream = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.05 16.5398C2.8 16.9198 3.63 17.3398 5 17.3398C6.37 17.3398 7.2 16.9198 7.95 16.5398L8.02968 16.5005C8.6442 16.1973 9.16581 15.9398 10 15.9398C10.9 15.9398 11.4 16.1898 12.05 16.5398L12.1283 16.5785C12.8575 16.9391 13.6678 17.3398 15 17.3398C16.3712 17.3398 17.1895 16.9252 17.9356 16.5471L17.95 16.5398L17.9755 16.5269C18.6137 16.2028 19.1315 15.9398 20 15.9398L20 14.0098C18.6709 14.0098 17.8264 14.4266 17.0849 14.7926L17.05 14.8098L17.0245 14.8228C16.3863 15.1469 15.8685 15.4098 15 15.4098C14.12 15.4098 13.6 15.1598 12.95 14.8098L12.9356 14.8025C12.1895 14.4245 11.3712 14.0098 10 14.0098C8.66784 14.0098 7.85752 14.4105 7.12827 14.7712L7.05 14.8098L6.97032 14.8491C6.35579 15.1524 5.83419 15.4098 5 15.4098C4.1 15.4098 3.6 15.1598 2.95 14.8098C2.2 14.4298 1.37 14.0098 2.91118e-07 14.0098L1.20643e-07 15.9598C0.9 15.9598 1.4 16.2098 2.05 16.5398ZM7.91508 7.67707C7.17356 8.04306 6.32909 8.45984 5 8.45984C3.65 8.45984 2.8 8.03984 2.05 7.65984C1.4 7.30984 0.900001 7.05984 8.98706e-07 7.05984L1.06918e-06 5.10984C1.37 5.10984 2.2 5.52984 2.95 5.90984C3.6 6.25984 4.1 6.50984 5 6.50984C5.9 6.50984 6.4 6.25984 7.05 5.90984L7.12827 5.87117C7.85752 5.51055 8.66784 5.10984 10 5.10984C11.3712 5.10984 12.1895 5.52449 12.9356 5.90255L12.95 5.90984C13.6 6.25984 14.1 6.50984 15 6.50984C15.9 6.50984 16.4 6.25984 17.05 5.90984L17.0849 5.89261C17.8264 5.52663 18.6709 5.10984 20 5.10984L20 7.05984C19.1642 7.05984 18.6532 7.31239 18.0471 7.61191L17.95 7.65984L17.8717 7.69852C17.1425 8.05914 16.3322 8.45984 15 8.45984C13.6288 8.45984 12.8105 8.0452 12.0644 7.66714L12.05 7.65984C11.4 7.30984 10.9 7.05984 10 7.05984C9.16581 7.05984 8.64421 7.31727 8.02968 7.62055L7.95 7.65984L7.91508 7.67707ZM7.95 3.20984C7.2 3.58984 6.35 4.00984 5 4.00984C3.65 4.00984 2.8 3.58984 2.05 3.20984C1.4 2.85984 0.900001 2.60984 1.28774e-06 2.60984L1.45821e-06 0.659842C1.37 0.659842 2.2 1.07984 2.95 1.45984C3.6 1.80984 4.1 2.05984 5 2.05984C5.86819 2.05984 6.39779 1.79096 7.04594 1.4619L7.05 1.45984L7.0644 1.45254C7.81051 1.07448 8.62883 0.659842 10 0.659843C11.3712 0.659843 12.1895 1.07449 12.9356 1.45255L12.95 1.45984C13.6 1.80984 14.12 2.05984 15 2.05984C15.8685 2.05984 16.3863 1.79688 17.0245 1.47279L17.05 1.45984C17.8 1.07984 18.65 0.659843 20 0.659843L20 2.60984C19.1315 2.60984 18.6137 2.87281 17.9755 3.1969L17.95 3.20984L17.9356 3.21714C17.1895 3.5952 16.3712 4.00984 15 4.00984C13.6288 4.00984 12.8105 3.5952 12.0644 3.21714L12.05 3.20984C11.4 2.85984 10.9 2.60984 10 2.60984C9.13181 2.60984 8.60221 2.87872 7.95406 3.20778L7.95 3.20984ZM7.91509 12.1271C7.17356 12.4931 6.3291 12.9098 5 12.9098C3.65 12.9098 2.8 12.4898 2.05 12.1098C1.4 11.7598 0.9 11.5098 5.09675e-07 11.5098L6.80149e-07 9.55984C1.37 9.55984 2.2 9.97984 2.95 10.3598C3.6 10.7098 4.1 10.9598 5 10.9598C5.83419 10.9598 6.3558 10.7024 6.97032 10.3991C6.9967 10.3861 7.02325 10.373 7.05 10.3598C7.076 10.347 7.10208 10.3341 7.12827 10.3212C7.85752 9.96055 8.66784 9.55984 10 9.55984C11.3712 9.55984 12.1895 9.97449 12.9356 10.3525L12.95 10.3598C13.6 10.7098 14.13 10.9598 15 10.9598C15.8342 10.9598 16.3558 10.7024 16.9703 10.3991C16.9967 10.3861 17.0232 10.373 17.05 10.3598C17.0616 10.3541 17.0733 10.3484 17.0849 10.3426C17.8264 9.97663 18.6709 9.55984 20 9.55984L20 11.5098C19.1 11.5098 18.6 11.7598 17.95 12.1098C17.924 12.1227 17.8979 12.1356 17.8717 12.1485C17.1425 12.5091 16.3322 12.9098 15 12.9098C13.6288 12.9098 12.8105 12.4952 12.0644 12.1171L12.05 12.1098C11.4 11.7598 10.9 11.5098 10 11.5098C9.1 11.5098 8.6 11.7598 7.95 12.1098L7.91509 12.1271Z"
      fill={fill}
    />
  </svg>
);

export const Column = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 0V13H17V0H0ZM10 2V11H7V2H10ZM2 2H5V11H2V2ZM15 11H12V2H15V11Z"
      fill={fill}
    />
  </svg>
);

export const OpenInNew = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8333 15.8333H4.16667V4.16667H10V2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10H15.8333V15.8333ZM11.6667 2.5V4.16667H14.6583L6.46667 12.3583L7.64167 13.5333L15.8333 5.34167V8.33333H17.5V2.5H11.6667Z"
      fill={fill}
    />
  </svg>
);

export const AccountSwitch = ({
  fill = '#687587',
  'data-testid': dataTestId,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 9C22 9 22 13 22 13V15H16V13C16 13 16 11.31 14.85 9.8C14.68 9.57 14.47 9.35 14.25 9.14C14.77 9.06 15.34 9 16 9ZM8 11C11.5 11 11.94 12.56 12 13H4C4.06 12.56 4.5 11 8 11ZM8 9C2 9 2 13 2 13V15H14V13C14 13 14 9 8 9ZM9 17V19H15V17L18 20L15 23V21H9V23L6 20L9 17ZM8 3C8.55 3 9 3.45 9 4C9 4.55 8.55 5 8 5C7.45 5 7 4.55 7 4C7 3.45 7.45 3 8 3ZM8 1C6.34 1 5 2.34 5 4C5 5.66 6.34 7 8 7C9.66 7 11 5.66 11 4C11 2.34 9.66 1 8 1ZM16 1C14.34 1 13 2.34 13 4C13 5.66 14.34 7 16 7C17.66 7 19 5.66 19 4C19 2.34 17.66 1 16 1Z"
      fill={fill}
    />
  </svg>
);

export const ConvertToAi = ({
  fill = '#687587',
  'data-testid': dataTestId,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 5.18L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L20.59 3.78L22 5.18ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C13.57 4 15.04 4.46 16.28 5.25L17.73 3.8C16.1 2.67 14.13 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C13.73 22 15.36 21.56 16.78 20.78L15.28 19.28C14.28 19.74 13.17 20 12 20ZM19 15H16V17H19V20H21V17H24V15H21V12H19V15Z"
      fill={fill}
    />
  </svg>
);

export const Goblet = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 5H17V3H7V5H5C3.9 5 3 5.9 3 7V8C3 10.55 4.92 12.63 7.39 12.94C8.02 14.44 9.37 15.57 11 15.9V19H7V21H17V19H13V15.9C14.63 15.57 15.98 14.44 16.61 12.94C19.08 12.63 21 10.55 21 8V7C21 5.9 20.1 5 19 5ZM5 8V7H7V10.82C5.84 10.4 5 9.3 5 8ZM12 14C10.35 14 9 12.65 9 11V5H15V11C15 12.65 13.65 14 12 14ZM19 8C19 9.3 18.16 10.4 17 10.82V7H19V8Z"
      fill={fill}
    />
  </svg>
);

export const Bell = ({ fill = '#687587', 'data-testid': dataTestId }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64003 5.36 6.00003 7.92 6.00003 11V16L4.00003 18V19H20V18L18 16ZM16 17H8.00003V11C8.00003 8.52 9.51003 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17ZM7.58003 4.08L6.15003 2.65C3.75003 4.48 2.17003 7.3 2.03003 10.5H4.03003C4.18003 7.85 5.54003 5.53 7.58003 4.08ZM19.97 10.5H21.97C21.82 7.3 20.24 4.48 17.85 2.65L16.43 4.08C18.45 5.53 19.82 7.85 19.97 10.5Z"
      fill={fill}
    />
  </svg>
);

export const SubdirectoryArrowRight = ({
  fill = '#687587',
  'data-testid': dataTestId,
}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    data-testid={dataTestId}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.25 11.25L9.75 15.75L8.685 14.685L11.3775 12L3 12L3 3L4.5 3L4.5 10.5L11.3775 10.5L8.685 7.815L9.75 6.75L14.25 11.25Z"
      fill={fill}
    />
  </svg>
);

export const Calendar = ({ fill = '#687587' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V10H20V21ZM20 8H4V5H20V8Z"
      fill={fill}
    />
  </svg>
);
